module.exports = __webpack_public_path__ + "static/media/verify.aa9f117d.svg";